import React from 'react';
import PropTypes from 'prop-types';
import RippleButton from '../Forms/RippleButton';

const SepaTransferInstructions = (props) => {

const instructions = props.instructions?.payload;

  return (
    <div>
      <h4>Instructions</h4>
      
      {instructions && (
        <div>
          <p><strong>{instructions.Message}</strong></p>
          
          {/* SEPA Equity Deposit Instructions */}
          {instructions.SepaEquityDepositInstruction && props.assetType === 'EQ' && (
            <div>
              <h5>SEPA Equity Deposit Instructions</h5>
              <div className="beneficiary-account">
                <h5>Beneficiary Account Details:</h5>
                <dl>
                  <dt>Account Title:</dt>
                  <dd>{instructions.SepaEquityDepositInstruction.BeneficiaryAccount.AccountTitle}</dd>
                  <dt>IBAN:</dt>
                  <dd>{instructions.SepaEquityDepositInstruction.BeneficiaryAccount.IBAN}</dd>
                  <dt>Swift BIC Routing:</dt>
                  <dd>{instructions.SepaEquityDepositInstruction.BeneficiaryAccount.SwiftBicRouting}</dd>
                </dl>
              </div>
              
              <div className="important-notes">
                <h5>Important Notes:</h5>
                <ul>
                  <li>{instructions.SepaEquityDepositInstruction.ImportantNote.ImportantNoteContent1}</li>
                  <li>{instructions.SepaEquityDepositInstruction.ImportantNote.ImportantNoteContent2}</li>
                  <li>{instructions.SepaEquityDepositInstruction.ImportantNote.ImportantNoteContent3}</li>
                  <li>{instructions.SepaEquityDepositInstruction.ImportantNote.ImportantNoteContent4}</li>
                </ul>
              </div>
            </div>
          )}
          
          {/* SEPA Futures Deposit Instructions */}
          {instructions.SepaFuturesDepositInstruction && props.assetType === 'FU' && (
            <div>
              <h5>SEPA Futures Deposit Instructions</h5>
              <div className="beneficiary-account">
                <h5>Beneficiary Account Details:</h5>
                <dl>
                  <dt>Account Title:</dt>
                  <dd>{instructions.SepaFuturesDepositInstruction.BeneficiaryAccount.AccountTitle}</dd>
                  <dt>IBAN:</dt>
                  <dd>{instructions.SepaFuturesDepositInstruction.BeneficiaryAccount.IBAN}</dd>
                  <dt>Swift BIC Routing:</dt>
                  <dd>{instructions.SepaFuturesDepositInstruction.BeneficiaryAccount.SwiftBicRouting}</dd>
                </dl>
              </div>
              
              <div className="important-notes">
                <h5>Important Notes:</h5>
                <ul>
                  <li>{instructions.SepaFuturesDepositInstruction.ImportantNote.ImportantNoteContent1}</li>
                  <li>{instructions.SepaFuturesDepositInstruction.ImportantNote.ImportantNoteContent2}</li>
                  <li>{instructions.SepaFuturesDepositInstruction.ImportantNote.ImportantNoteContent3}</li>
                  <li>{instructions.SepaFuturesDepositInstruction.ImportantNote.ImportantNoteContent4}</li>
                </ul>
              </div>
            </div>
          )}
        </div>
      )}


      {props.showPrintButton &&
        <RippleButton className="primary" onClick={(e) => props.printPage(e)}>PRINT</RippleButton>}
    </div>
  );
};

SepaTransferInstructions.propTypes = {
  accountNumber: PropTypes.string.isRequired,
  printPage: PropTypes.func.isRequired,
  showPrintButton: PropTypes.bool,
};

export default SepaTransferInstructions;
